module.exports = __webpack_public_path__ + "img/function_left.1e235964.png";